import { combineReducers } from 'redux';
import list from './list';
import timetable from './timetable';
import search from './search';
import filter from './filter';

export default combineReducers({
    list,
    timetable,
    search,
    filter
});
